(function () {
  angular.module('MktzapApp.Directives').directive('formatCpfOnCopy', function ($window) {
    function customCopy (elToCopy, cbData) {
      var el = document.getElementById(elToCopy);
      var toCopy = el.value.replace(/[.-]/g, '');
      try {
        if (cbData) {
          cbData.setData('text/plain', toCopy);
        } else if (window.clipboardData) {
          window.clipboardData.setData('Text', toCopy);
        }
      } catch (err) {
      }
    }
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.on('copy', function (e) {
          e.preventDefault();
          customCopy(attrs.formatCpfOnCopy, e.originalEvent.clipboardData);
        });
      }
    }
  })
}).call(this);
